import {
    Delete as DeleteIcon,
    Edit as EditIcon,
    Add as AddIcon,
    AirplanemodeInactive,
    AirplanemodeActive,
} from "@material-ui/icons";
import DataTable from "../../../components/data-table";
import FormModalContent from "./form";
import ConfirmModalContent from "../../../components/confirm-modal-content";
import glassesService from "../../../services/glasses.service";

const defaultKeys = [
    {
        title: "نام",
        field: "title",
        active: true,
    },
    {
        title: "تعداد عینک",
        field: "glassCount",
        active: false,
    },
];

const headerCells = [
    {
        field: "title",
        title: "عنوان",
        mainField: true,
    },
    {
        field: "glassCount",
        title: "تعداد عینک",
        mainField: false,
    },
    {
        field: "discount",
        title: "درصد تخفیف",
        mainField: false,
    },
    {
        field: "isActiveText",
        title: "وضعیت",
        mainField: false,
    },
];

export default function GroupsToChange() {

    const deleteItem = (item) => {
        return glassesService.handleDeleteGroupOfChange(item.id);
    };

    const handleToggleStatus = (item) => {
        return glassesService.handleToggleActiveGroupOfChange(item.id);
    };

    const changeData = (data) => {
        return data.map(item => {
            try {
                item.glassesId = JSON.parse(item.glassesId);
            } catch (err) {
                item.glassesId = []
            }
            item.glassCount = item.glassesId.length;
            item.isActiveText = item.isActive ? "فعال" : "غیرفعال"

            return item;
        });
    }

    return (
        <div className="p-2">
            <DataTable
                headCells={headerCells}
                backend={glassesService.getGroupOfChange}
                changeData={changeData}
                rowActions={[
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: (props) => {
                            return (
                                props.isActive ? <AirplanemodeActive /> : <AirplanemodeInactive />
                            )
                        },
                        modalContent: (props) => {
                            return (
                            <ConfirmModalContent
                                onConfirm={() => handleToggleStatus(props.data)}
                                description={`آیا می خواهید تغییر روی عینک ها را ${props.data.isActive ? "غیرفعال" : "فعال"} کنید؟`}
                                close={props.close}
                                confirmButtonText={props.data.isActive ? "غیرفعال" : "فعال"}
                            />
                        )
                        },
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <EditIcon />,
                        modalContent: (props) => <FormModalContent {...props} />,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <DeleteIcon />,
                        modalContent: (props) => (
                            <ConfirmModalContent
                                onConfirm={() => deleteItem(props.data)}
                                confirmText={props.data.title}
                                close={props.close}
                            />
                        ),
                    },
                ]}
                actions={[
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <AddIcon />,
                        tooltip: "ایجاد گروه تغییرات",
                        modalContent: (props) => <FormModalContent {...props} />,
                    },
                ]}
                searchKeys={defaultKeys}
                title="گروه تغییرات"
            />
        </div>
    );
}